export default "__VITE_ASSET__02c0e2b3__"